export default __webpack_public_path__ + "static/media/collections_7.64bbfc68.webp";